import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Avatar from "@mui/material/Avatar";
import ImageIcon from "@mui/icons-material/Image";

const DesignCards = () => {
  const card = (
    <div className="row m-0 p-0">
      <div className="col-md-2 d-none d-md-block"></div>
      <div className="col-md-8 col-12">
        <div className="row  mb-5 " dir="ltr">
          <div className="col-2 text-left my-auto mb-1 ">
            <Avatar>
              <ImageIcon />
            </Avatar>
          </div>
          <div className="col-3 col-md-3 text-left my-auto">
            <span>
              <Skeleton
                animation="wave"
                variant="rectangular"
                width={"100%"}
                height={25}
              />
            </span>
          </div>
          <div className="col-12">
            <Skeleton
              sx={{ marginTop: "0px" }}
              animation="wave"
              variant="rectangular"
              width={"100%"}
              height={450}
            />
          </div>

          <div className="col-12">
            <Skeleton
              sx={{ marginTop: "7px" }}
              animation="wave"
              variant="rectangular"
              width={"100%"}
              height={25}
            />
          </div>
        </div>
      </div>
      <div className="col-md-2 d-none d-md-block"></div>
    </div>
  );
  const cards = [];
  for (let i = 0; i < 10; i++) {
    cards.push(card);
  }
  return cards.map((card, index) => <div key={index}>{card}</div>);
};
export const SingleDesignCardSkeleton = () => {
  return (
    <div className="row  mb-5">
      <div className="col-12">
        <Skeleton
          sx={{ marginTop: "0px" }}
          animation="wave"
          variant="rectangular"
          width={"100%"}
          height={350}
        />
      </div>

      <div className="col-12">
        <Skeleton
          sx={{ marginTop: "7px" }}
          animation="wave"
          variant="rectangular"
          width={"100%"}
          height={25}
        />
      </div>
    </div>
  );
};
export default DesignCards;
